var map = {
	"./botanical_head.svg": "b410",
	"./calm.svg": "d340",
	"./ctg_arw.svg": "0738",
	"./feel_clear.svg": "5422",
	"./fun.svg": "a901",
	"./fun_slow.svg": "94d1",
	"./industrial_head.svg": "89dd",
	"./nordic_head.svg": "73a5",
	"./phyto.svg": "0c91",
	"./phyto_calm.svg": "b78a",
	"./slow.svg": "6002",
	"./sohostyle_head.svg": "c5ad",
	"./sudare.svg": "29e2",
	"./wa-.svg": "2a43",
	"./wa-hikaritokage.svg": "5aa0",
	"./wa-origeshiki.svg": "fdbd",
	"./wa-sudare.svg": "ef7f",
	"./wa_head.svg": "e35b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b75d";